module.exports = __webpack_public_path__ + "img/text07.45a1961b.svg";